<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn 
          class="mr-1" small color="primary" dark 
          v-on="{...tooltip}"
          v-on:click="()=>dialog=!dialog"
        >
          <v-icon>{{`${ (mode === 0) ? 'mdi-plus' : 'mdi-pencil-outline' }`}}</v-icon>
        </v-btn>
      </template>
      <span>{{ `${ (mode === 0) ? $t('referenceBooks.roles.Create') : $t('referenceBooks.roles.Edit')}` }}</span>
    </v-tooltip>
    <DragForm 
      v-model="dialog" 
    >
      <v-card width="800">
        <v-card-title>
          <span
            class="headline"
          >{{ `${ (mode === 0) ? $t('referenceBooks.roles.Create') : $t('referenceBooks.roles.Edit')}` }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="currentRole.description"
                  :label="this.$t('referenceBooks.roles.RoleName') + '*'"
                  required
                  :error-messages="errorMessage"
                  v-on:blur="onBlur"
                />
              </v-col>
            </v-row>
          </v-container>
          <small>*{{$t('referenceBooks.requiredFields')}}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">{{$t('Close')}}</v-btn>
          <v-btn v-if="mode===0" color="blue darken-1" text @click="createRole">{{$t('Create')}}</v-btn>
          <v-btn v-else color="blue darken-1" text @click="saveRole">{{$t('Save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>

<script>
import Vue from 'vue';
import {notifyError, notifySuccess} from '@/services/notifications';
import DragForm from '@/components/Forms/DragForm.vue';

export default {
  components: {
    DragForm,
  },
  name: 'RoleDialog',
  props: {
    mode: {
      type: Number,
      defaultItem: 0
    },
    role: {
      type: Object,
      defaultItem: {
        roleId: 0,
        description: ''
      }
    }
  },
  data() {
    return {
      currentRole: {
        bankName: '',
        description: ''
      },
      dialog: false,

      busyValues:{
        'Description': [],
      },
      wasBlurred: false,
      executeButtonClick: false,
    };
  },
  watch: {
    dialog(flag) {
      if(!flag)
        this.clear();
      else if(this.mode === 1)
        this.loadOne();
      else
        this.loadNull();
    }
  },
  computed: {    
    propertiesResponse() {
      return { 'Description' : this.$t('referenceBooks.roles.Name') };
    },
    errorMessage() {
      const name = this.currentRole.description;
      const check = this.executeButtonClick || 
                    this.wasBlurred ||
                    name != null && name.length != 0;
                    
      if (!check)
        return '';

      return this.checkText(name, 'Description');
    },
  },
  methods: {
    clear(){      
      this.wasBlurred = false;
      this.executeButtonClick = false;
      this.busyValues = {
        'Description': [],
      };
      this.currentRole = {
        description: ''
      };
    },
    loadOne(){
      if(this.role!= null){
        Object.assign(this.currentRole, this.role);
      }
    },
    loadNull(){

    },
    checkText(value, ind = null){
      if (value == null || value.length == 0) 
        return this.$t('validations.notEmpty');

      if(ind != null){
        if(this.busyValues[ind] != null && this.busyValues[ind].length != 0)
          if (this.busyValues[ind].indexOf(value, 0) != -1)
            return this.$t('errorsMessages.BusyName');
      }

      return '';
    },
    onBlur() {
      this.wasBlurred = true;
    },
    checkFields(){
      let result = true;
      const errors = this.checkText(this.currentRole.description, 'Description');

      if (errors != null && errors != ''){
        this.showMessage(`${this.$t('ErrorInField')}: ${this.$t('referenceBooks.roles.Name')}`, errors, 'error');
        result = false;
      }

      return result;
    },
    createRole() {
      this.executeButtonClick = true;

      if (!this.checkFields())
        return;
        // Проверка. Валидация
      this.$axios.roles
        .post({
          ...this.currentRole
        })
        .then(response => {
          if (response.status == 200){
            const id = response.data;
            notifySuccess('',this.$t('Messages.RoleWasCreated', [this.currentRole.description]));

            this.$emit('created', id);
            this.dialog = false;
          }
        })
        .catch((error) => {
          console.error(error);
            
          notifyError('',this.$t('Messages.ErrorOccuredWhileCreatingUser', [this.currentRole.description]));
          this.catchErrors(error);
        });
    },
    catchErrors(error, errorHeader = ''){
      const status = error.response.status;
      const data = [error.response.data];

      if (status === 400 || status === 401){
        for(let i = 0; i < data.length; i++)
          this.handlingError(data[i], errorHeader, error);
      }
      else{
        this.onUnknownError(error);
      }
    },
    handlingError(data, errorHeader, error){
      switch(data.errorType){
      case 'IS_BUSY':
        this.onBusy(data.property, data.value);
        break;
      case 'NO_RIGHTS':
        this.onNoRigths(errorHeader);
        break;
      default:
        this.onUnknownError('error', error);
        break;
      }
    },
    onBusy(property, value){
      this.busyValues[property].push(value);
      const errorInField = `${this.$t('ErrorInField')}: ${this.propertiesResponse[property]}`;

      this.showMessage(errorInField, this.$t('errorsMessages.BusyName'), 'error');
    },
    onNoRigths(errorHeader = ''){
      this.showMessage(
        `${errorHeader === '' ? this.$t('Error') : errorHeader}`,
        this.$t('errorsMessages.NoRights'),
        'error'
      );
    },
    onUnknownError(error){
      this.$emit('error', error);
    },
    saveRole() {
      this.executeButtonClick = true;

      if (!this.checkFields())
        return;

      this.$axios.roles.put(this.currentRole.roleId, this.currentRole)
        .then(() => {
          notifySuccess('',this.$t('Messages.RoleWasEdited', [this.currentRole.description]));

          this.$emit('saved', this.currentRole.roleId);
          this.dialog = false;
        })
        .catch(error => {
          console.error(error);
          
          notifyError('',this.$t('Messages.ErrorOccuredWhileCreatingRole', [this.currentRole.description]));

          this.catchErrors(error);
        });
    },
    showMessage(title, text, type = ''){
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
    getData(){
      this.$axios.roles
        .getById(this.roles.roleId)
        .then(response => response.data)
        .then(json => (this.currentRole = json[0]))
        .catch(error => console.error(error));
    },
  },
  async mounted() {

  }
};
</script>